import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['form']
  static values = {
    fieldName: String,
    defaultFilters: Array
  }

  resetFilters() {
    for (let input of this.formTarget.querySelectorAll('input[type="hidden"][name^="filters"]')) {
      let name = input.name
      if (!name.includes(this.fieldNameValue) && !this.isDefault(name)) {
        input.remove()
      }
    }
    this.dispatch('reload-form')
  }

  isDefault(name) {
    let findDefault = this.defaultFiltersValue.find((defaultFilter) => {
      return name.includes(defaultFilter)
    })
    return findDefault !== undefined
  }
}
